export const examCheckerWalkThroughPhase = 'examCheckerWalkThroughPhaseV3';

export enum ExamCheckerWalkthroughPhase {
  First = 'first',
  Second = 'second',
  Third = 'third',
  Fourth = 'fourth',
  Done = 'done',
}
